<template lang="pug">
  .column.is-11
    data-notification(icon="shopping_cart" v-bind:loading="expenses.isLoading" type="is-info")
      p.title Despesas
      p.subtitle {{expenses.data}} {{expenses.data | pluralize('cadastrada')}} este mês
    article.card.table-card
      header.card-header
        p.card-header-title Despesas Aprovadas a Vencer
      .card-content.is-paddingless
        b-table(
          v-bind:data="expensesDue.data",
          v-bind:striped="true",
          v-bind:narrowed="false",
          v-bind:mobile-cards="false",
          v-bind:loading="expensesDue.isLoading",
          v-bind:row-class="getRowClass"
        )
          template(slot-scope="props")
            b-table-column(label="Nome") {{props.row.name}}
            b-table-column(label="Tipo") {{props.row.type}}
            b-table-column(label="Valor") {{props.row.value | currency}}
            b-table-column(label="Data Vencimento" v-bind:class="{'has-text-danger': props.row.due_date <= today}") {{props.row.due_date | moment('DD/MM/YYYY')}}
            b-table-column(label="Status Análise")
              b-tag(v-bind:type="statusClass[props.row.payment.status]") {{ statusLabel[props.row.payment.status] }}
            b-table-column(centered label="Gerenciar Pagamento")
              b-tooltip(label="Alterar Pagamento da Despesa" type="is-dark")
                router-link(v-bind:to="{name: 'paymentExpenseEdit', params: {id: props.row._id}}")
                  span &nbsp;&nbsp; #[b-icon(icon="edit" type="is-primary" size="is-small")]
            b-table-column(centered label="Gerenciar Despesa")
              b-tooltip(label="Alterar Despesa" type="is-dark")
                router-link(v-bind:to="{name: 'expenseEdit', params: {id: props.row._id}}")
                  span &nbsp;&nbsp; #[b-icon(icon="edit" type="is-primary" size="is-small")]
          template(slot="empty")
            section.section
              .content.has-text-grey.has-text-centered
                p
                  b-icon(icon="sentiment_very_dissatisfied", size="is-large")
                p Nenhum dado.
</template>

<script>
  import DataNotification from './DataNotification'

  import ExpenseService from '@/services/expense.js'
  const {statusLabel, statusClass} = ExpenseService

  export default {
    name: 'ExpensesDue',
    components: {DataNotification},
    data () {
      return {
        today: this.$moment().startOf('day').toISOString(),
        startOfMonth: this.$moment().startOf('isoMonth').toISOString(),
        expensesDue: {isLoading: false, data: []},
        expenses: {isLoading: false, data: 0},
        statusLabel,
        statusClass
      }
    },
    async created () {
      this.fetchExpenses()
      this.fetchExpensesDue()
    },
    methods: {
      getRowClass (row) {
        if (row.due_date <= this.today) return 'is-danger'
      },
      async fetchExpenses (params) {
        let query = {created_at: {$gte: this.startOfMonth}, limit: 1}
        query = Object.assign(query, params)
        this.expenses.isLoading = true
        const response = await ExpenseService.query(query)
        this.expenses.isLoading = false
        this.expenses.data = response.body.meta.count
      },
      async fetchExpensesDue (params) {
        let query = {payment: {paid: false, status: 'approved'}, limit: 20, sort: {due_date: 'asc'}}
        query = Object.assign(query, params)
        this.expensesDue.isLoading = true
        const response = await ExpenseService.query(query)
        this.expensesDue.isLoading = false
        this.expensesDue.data = response.body.expenses
      }
    }
  }
</script>

<style lang="sass" scoped>
  .table-card
    min-height: 15rem
</style>



// WEBPACK FOOTER //
// ExpensesDue.vue?6b405f54